import { DESKTOP_SIDEBAR_EXPANDED_WIDTH } from "../components/header/header_styled_components";

// Narrow enough that labels are clipped to a few characters, which is a shape some
// people deliberately want — icons plus a hint of the label — so the panel stays
// draggable down to here instead of snapping to the rail as soon as it gets tight.
export const DESKTOP_SIDEBAR_MIN_WIDTH = 116;
export const DESKTOP_SIDEBAR_MAX_WIDTH = DESKTOP_SIDEBAR_EXPANDED_WIDTH;

// Dragging the handle left of this point collapses the panel into the rail — it sits
// between the rail's own width and the narrowest the panel is allowed to be.
export const DESKTOP_SIDEBAR_COLLAPSE_THRESHOLD = 95;

export const shouldCollapseAtWidth = (rawWidth: number): boolean =>
	rawWidth < DESKTOP_SIDEBAR_COLLAPSE_THRESHOLD;

export const clampSidebarWidth = (value: number): number =>
	Math.min(DESKTOP_SIDEBAR_MAX_WIDTH, Math.max(DESKTOP_SIDEBAR_MIN_WIDTH, Math.round(value)));
